import { NewsCardProps, UI_NewsCard } from 'ui/components/2-molecules/Card/NewsCard/NewsCard';
import styles from './NewsOverview.module.scss';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';

export interface NewsOverviewProps {
	cards: NewsCardProps[];
	paginationText: string;
	requestMoreCards?: () => void;
}

export const UI_NewsOverview = ({ cards, paginationText, requestMoreCards }: NewsOverviewProps) => {
	return (
		<div className={styles.NewsOverview}>
			{cards?.map((card, index) => {
				return <UI_NewsCard className={styles.NewsOverview_card} key={index} {...card} />;
			})}
			{paginationText && (
				<div className={styles.NewsOverview_pagination}>
					<UI_Button style="secondary" onClick={requestMoreCards}>
						{paginationText}
					</UI_Button>
				</div>
			)}
		</div>
	);
};
